import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Button } from 'Components';
import { NotificationManager } from 'Components/Notifications';

import {
  deleteRouteStop,
  openStopDelete,
  clearRedux
} from 'Redux/actions';


const RouteDelete = (props) => {
  const dispatch = useDispatch();
  const { callBack } = props;
  const { messages } = useIntl();


  const {
    openDelete,
    stops,
    responseDelete,
    loadingDelete
  } = useSelector((state) => state.RoutesRedux);



  useEffect(() => {
    if (responseDelete === true) {
      NotificationManager.success(
        messages['FSM_SETTINGS_ROUTE_DELETE'],
        messages['success'],
        3000,
        null,
        null,
        'Success',
      );
      dispatch(clearRedux("FSM_ROUTES_STOP", {
        responseDelete: false
      }));
      handleClose();
    }
  }, [responseDelete]);


  const handleClose = useCallback(() => {
    dispatch(clearRedux("FSM_ROUTES_STOP", {
      responseDelete: false
    }));

    callBack();
    dispatch(openStopDelete(false, []));
  });

  return (
    <Modal
      title={messages["FSM_SETTINGS_ROUTE_DELETE_TITLE"]}
      open={openDelete}
      position="right"
      size="small"
      handleClose={() => {
        dispatch(clearRedux("FSM_ROUTES_STOP", {
          responseDelete: false
        }));
        dispatch(openStopDelete(false, []))

      }}
    >
      <ModalBody>
        <div style={{ padding: '18px 24px 24px 24px', height: 650 }}>

          <div>
            <p>
              {messages["FSM_SETTINGS_ROUTE_DELETE_BODY"]}
            </p>
            <p>
              {messages["FSM_SETTINGS_DRIVER_STATUS_delete_warning"]}
            </p>
          </div>

          <div style={{ padding: 10 }}>
            <ul>
              {
                stops
                &&
                stops.map((Route, index) => {
                  return (
                    <li key={index}>
                      <span>{Route.name}</span>
                    </li>
                  )
                })
              }
            </ul>
          </div>

        </div>
      </ModalBody>

      <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }} >
        <Button
          disabled={loadingDelete}
          onClick={() => {
            dispatch(clearRedux("FSM_ROUTES_STOP", {
              responseDelete: false
            }));
            dispatch(openStopDelete(false, []))

          }}
          className="btn-cancel"
        >
          {messages['cancel']}
        </Button>

        <Button
          disabled={loadingDelete}
          onClick={(e) => {
            if (e) e.preventDefault();
            dispatch(deleteRouteStop(stops));
          }}
          className="btn-red"
        >
          {messages['delete']}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default RouteDelete;